import React, { useEffect } from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { TextBox } from 'components/form/TextBox/TextBox';
import Label from 'components/form/Label/Label';
import { DropDown } from 'components/form/DropDown/DropDown';

const AddressFormOneClickApplication = props => {
  const { addressForm, states } = props;

  useEffect(() => {
    addressForm.isAddressValid({
      street: addressForm.street,
      zip: addressForm.zip,
      city: addressForm.city,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressForm.street, addressForm.zip, addressForm.city]);

  return (
    <FlexContainer className="flex-column gap-8">
      <Label typeHeader={'h4'} className="H4 text-16">
        Address
      </Label>
      <FlexContainer className="margb16 flex-column">
        <TextBox
          id="current-street"
          name="street"
          datatestid="streetInput"
          type="text"
          placeholder="Street Address"
          aria-required="true"
          aria-invalid="false"
          value={addressForm.street}
          error={addressForm.streetError}
          fullWidth={true}
          onChange={e => {
            e.persist();
            addressForm.handleChange?.(e);
            addressForm.googleAutocomplete?.handleAutocomplete?.(e);
          }}
        />
      </FlexContainer>
      <FlexContainer className="m-flex-column justify-between">
        <FlexContainer className="flex-column textBoxw260 margb16">
          <TextBox
            id="city"
            name="city"
            datatestid="city"
            placeholder="City"
            type="text"
            value={addressForm.city}
            onChange={addressForm.handleChange}
            fullWidth={true}
            error={addressForm.cityError}
          />
        </FlexContainer>
        <FlexContainer className="flex-column textBoxw165 margb16">
          <DropDown
            id="current-state"
            datatestid="stateInput"
            onChange={value => addressForm.handleUSStateChange(value)}
            isEmptyState={!addressForm.displayState}
            list={states}
            label="State"
            value={addressForm.displayState}
            error={addressForm.stateError}
            placeholder="State"
            fullWidth={true}
            internalPlaceholder={'State'}
          />
        </FlexContainer>
        <FlexContainer className="flex-column textBoxw185">
          <TextBox
            id="zip"
            name="zip"
            datatestid="zip"
            placeholder="Zip"
            onChange={addressForm.handleChange}
            value={addressForm.zip}
            error={addressForm.zipError}
            fullWidth={true}
          />
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default AddressFormOneClickApplication;
